import * as React from 'react'
import PropTypes from 'prop-types'

import cssModules from 'react-css-modules'
import { Button, Dialog } from '@paypalcorp/pp-react'
import StandardError from 'components/common/standard_error'
import styles from './payments_token_sheet.less'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/common/campaign_eligibility')
const i18nBack = getI18n('components/back_button')

class PaymentsTokenSheet extends React.Component {
  static propTypes = {
    onClose: PropTypes.function,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    subTitle: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose() {
    this.props.onClose()
  }

  render() {
    const { isOpen } = this.props

    return (
      <>
        {isOpen && (
          <Dialog
            hideTitle
            isOpen={this.props.isOpen}
            onClose={this.handleClose}
            title="Donation Error"
            center
            closeOnBackgroundClick
            isFullView
            containerClassName={styles.container_class}
          >
            <div styleName="error-wrapper">
              <StandardError
                center
                title={i18n('title.ERROR')}
                backButton={false}
                iconType="warning"
                extraContent={
                  <Button
                    styleName="back-button"
                    secondary
                    onClick={this.handleClose}
                  >
                    {i18nBack('back')}
                  </Button>
                }
              />
            </div>
          </Dialog>
        )}
      </>
    )
  }
}
export default cssModules(PaymentsTokenSheet, styles)
